import React from 'react';

const FoundingTeamSection = () => {
  return (
    <section className="py-24 px-4 md:px-6 lg:px-8 border-t border-border">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl font-bold text-foreground mb-4 md:mb-6">
          Meet Our Founding Team
        </h2>
        <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
          Built by engineers, for engineers. We understand the challenges of hardware development because we've lived them.
        </p>
      </div>
    </section>
  );
};

export default FoundingTeamSection;